import React from 'react';
import './forbidden.css'

export default class Forbidden extends React.Component {
    render() {
        return (
            <div>
                <section className="content">
                    <div className="error-page">
                        <h2 className="headline text-red"> 403</h2>
                        <div className="error-content">
                            <h3><i className="fa fa-warning text-red"></i> Упс! Отказ в доступе.</h3>
                            <p>Недостаточно прав для доступа к запрашиваемой странице.</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./App/pages/forbidden/forbidden.jsx